import React, { useState, useCallback } from "react";
import { faForwardStep } from "@fortawesome/free-solid-svg-icons";
import type { DevToolsPlugin } from "../../types";

function SkipToQcpPanel() {
  const [skipping, setSkipping] = useState(false);

  const handleSkip = useCallback(() => {
    setSkipping(true);

    const form =
      document.querySelector<HTMLFormElement>(
        "form.mobius-submission__questionnaire-form",
      ) ||
      document
        .querySelector<HTMLButtonElement>(
          ".btn-primary.arrow.qa-next-button.js-next-button",
        )
        ?.closest("form");

    if (!form) {
      setSkipping(false);
      return;
    }

    let hiddenField = form.querySelector<HTMLInputElement>(
      'input[name="skip_to_qcp"]',
    );
    if (!hiddenField) {
      hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = "skip_to_qcp";
      form.appendChild(hiddenField);
    }
    hiddenField.value = "true";
    // requestSubmit triggers React onSubmit handlers; submit() bypasses them.
    form.requestSubmit();
  }, []);

  return (
    <>
      <div className="dt-skip__description">
        Skip directly to the Quote Comparison Page, bypassing remaining
        questionnaire steps.
      </div>
      <button
        className="dt-btn dt-btn--primary"
        onClick={handleSkip}
        disabled={skipping}
        type="button"
        style={{ width: "100%" }}
      >
        {skipping ? "Skipping..." : "Skip to QCP"}
      </button>
    </>
  );
}

export function skipToQcpPlugin(): DevToolsPlugin {
  return {
    id: "skip-to-qcp",
    name: "Skip to QCP",
    icon: faForwardStep,
    render: () => <SkipToQcpPanel />,
  };
}
